// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"40a31aec","321":"307d6dd6","345":"fa394687","734":"9bf9c756","837":"8a26afb6","972":"6215d987"}[chunkId] + ".css";
};